'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon, $this, pid) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
        if ($this.hasClass('secondary-button-wishlist-js')) {
            $this.find('.wishlist-tile-color').text('Wishlisted');
        }
        $this.removeClass('wishlistTile').addClass('remove-from-wishlist');
        
        // handle click on icon on product Tile else click on button in quickview / pdp
        if(icon.closest('fa-stack')>0){
            icon.addClass('fa-heart').removeClass('fa-heart-o');
        }else{
            icon.addClass('fa-heart').removeClass('fa-heart-o d-none').removeAttr('style');
        }

        // for PDP sticky button copy content from first button in sticky button
        var clickedButton = $this[0];
        if($this.closest('.prices-add-to-cart-actions').length) {
            $('.prices-add-to-cart-actions').find('.secondary-button-wishlist-js').removeClass('wishlistTile').addClass('remove-from-wishlist')
            .html(clickedButton.innerHTML)
            .attr('data-url',clickedButton.dataset.url)
            .attr('href',clickedButton.href);
        }

        // Update heart icon on product tile
        if($('body').hasClass('modal-open')){
            $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').removeClass('wishlistTile').addClass('remove-from-wishlist');
            $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').find('.fa').removeClass('fa-heart-o').addClass('fa-heart');
        }
        
    } else {
        $this.addClass('remove-from-wishlist').removeClass('wishlistTile');
        status = 'alert-danger';
    }

    var viewSizes = $(window).width();
    if ($('.add-to-wishlist-messages').length === 0) {        
        if (viewSizes <= 540 && $('header').hasClass('sticky-header')) {
            $('body').append('<div class="add-to-wishlist-messages "></div>');
        }else{
            $('header .header').append('<div class="add-to-wishlist-messages "></div>');
        }
    }
    
    $('.add-to-wishlist-messages').append('<div class="add-to-wishlist-alert text-left ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile', function (e) {
            e.preventDefault();
            var $this = $(this);
            var icon = $(this).find($('i'));
            var url = $(this).attr('href');
            var pid = $(this).closest('.product').attr('data-pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }
            if ($('.modal').hasClass('show')) {
                sessionStorage.setItem('quickViewWishlist', true);
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    if(data.success) {
                        if(data.dataForWishlistGA){
                            let dataForWishlistGA = data.dataForWishlistGA;
                            dataForWishlistGA.currentPage = window.location.href;
                            dataForWishlistGA.nextPage = window.location.href;
                            window.dataLayer.push(dataForWishlistGA);
                        }
                        $('body').trigger('sfmcWishlistTrack', pid);
                        displayMessageAndChangeIcon(data, icon, $this, pid);
                        if ($('.wishlist-quantity').length) {
                            $('.wishlist-quantity').text(data.quantityTotal);
                        } else {
                            $('.header-desktop-wishlist-icon, .header-mobile-wishlist-icon').append('<span class="wishlist-quantity">'+data.quantityTotal+'</span>');
                        }
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon, $this, pid);
                }
            });
            $.spinner().stop();
        });
    }
};
